export const ASYNC_FETCH = 'ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESS = 'ASYNC_FETCH_SUCCESS';
export const ASYNC_FETCH_FAILURE = 'ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ASYNC_FETCH_INVALIDATE';
export const SHOW_VIDEO_CHAT_ASSIST = 'SHOW_VIDEO_CHAT_ASSIST';

export const storeDetailVApolling = {
  maxPollCount: 10,
  pollingTimer: 30,
  errorTimer: 30,
  maxErrorCount: 3,
};
